module.exports = __webpack_public_path__ + "img/file-alt-regular.af630b38.svg";